export const isMobileView = layout => layout === "mobile";

export const isDektopView = layout => layout === "desktop";
